
import mixins from "vue-typed-mixins";
import Modal from "@/components/Modal.vue";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import dayjs from "dayjs";
export default mixins(ConfirmationModalMixin,SnackbarNotifierMixin).extend({
  name: 'PromoCodeReportModal',
  components: {Modal, ConfirmationModal, SnackbarNotifier},
  props: {
    value: {
      type: Boolean,
      required: true
    },
    promoCodes: {
        type: Array,
        default: () => []
    }
  },
  data: () => ({
    selected: [],
    dateRange: [dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],
    exporting: false
  }),
  computed: {
    dateRangeObject(){
        let startDate = "", endDate = "";
        try{
            if(!this.dateRange || this.dateRange.length < 2){
                return {startDate, endDate};
            }

            startDate = this.dateRange[0];

            endDate = this.dateRange[1];

            if(dayjs(this.dateRange[0]).isAfter(dayjs(this.dateRange[1]))){
                startDate = this.dateRange[1];

                endDate = this.dateRange[0];
            }
        }catch(e){
            error(e);
        }
        return {startDate, endDate};
    }
  },
  methods: {
    async exportReport(){
      try{
        this.startConfirmationLoading();
        this.exporting = true;
        await ApiService.Instance.promoCodeReport({
            promoCodeIds: this.selected,
            shouldRetrieveAll: this.selected.length < 1,
            startDate: this.dateRangeObject.startDate,
            endDate: this.dateRangeObject.endDate
        })
        this.stopConfirmationLoading();
        this.exporting = false;
        this.showNotifier({
          message: 'Successfully Exported The Report',
          snackbarType: 'success'
        })
      }
      catch(err){
        this.showNotifier({
          message: 'Failed To Export The Report',
          snackbarType: 'error'
        })
        this.stopConfirmationLoading();
        this.exporting = false;
        error(err)
      }
    },
    reset(){
        this.selected = [];
        this.dateRange = [dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")];
        this.exporting = false;
    },
    closeModal(){
        this.reset();
        this.$emit('closeModal');
    },
  }

})
